// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"694":"5bf76f16","922":"7a9412ec"}[chunkId] + ".chunk.js";
};